// extracted by mini-css-extract-plugin
export var bodyRow = "_cc-d";
export var cardColumns = "_cc-e";
export var ellipsesOverflow = "_cc-2";
export var flatBottomCorners = "_cc-3";
export var flatTopCorners = "_cc-4";
export var headerActionsDropdown = "_cc-f";
export var headerBottomRow = "_cc-c";
export var headerTopRow = "_cc-b";
export var orderDetailsWrapper = "_cc-0";
export var orderInfoContainer = "_cc-1";
export var productDetails = "_cc-9";
export var productImage = "_cc-5";
export var responsiveTable = "_cc-8";
export var shipmentContainer = "_cc-a";
export var tableBottomLeft = "_cc-6";
export var tableBottomRight = "_cc-7";
export var trackingLink = "_cc-g";